module.exports = __webpack_public_path__ + "img/fluessig.7d2d8289.jpg";